import { Store, ChevronDown } from 'lucide-react';
import { NotificationBell } from '@/components/notifications/NotificationBell';
import { TopNavSearch } from './TopNavSearch';

interface TopNavProps {
  shopName?: string;
}

export function TopNav({ shopName = 'My Store' }: TopNavProps) {
  return (
    <header className="sticky top-0 z-20 flex h-[60px] shrink-0 items-center gap-3 border-b border-border bg-surface/95 px-4 backdrop-blur supports-[backdrop-filter]:bg-surface/80 lg:px-5">
      <TopNavSearch />

      <div className="flex flex-1 items-center justify-end gap-2">
        <button className="hidden items-center gap-1.5 rounded-md border border-border px-3 py-1.5 text-[14px] font-medium text-text-secondary hover:bg-bg sm:flex">
          <Store size={16} />
          <span className="max-w-[140px] truncate">{shopName}</span>
          <ChevronDown size={14} />
        </button>

        <NotificationBell />

        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-subtle text-[14px] font-semibold text-primary">
          {shopName.charAt(0).toUpperCase()}
        </div>
      </div>
    </header>
  );
}
